import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PieceHtmlContainerRenderComponent } from './render/piece-html-container-render.component';
import { SharedModule } from 'shared/shared.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { SharedComponentsModule } from 'extensions/oy/shared-components/shared-components.module';
import { CmcToCmsParserService } from './services/cmc-to-cms-parser.service';
import { TranslatePipe } from 'extensions/oy/pipes/translate.pipe';
import { TranslatePipeModule } from 'extensions/oy/pipes/translate.pipe.module';
import { TranslateService } from 'extensions/oy/services/translate/translate.service';

export const pieceHtmlContainerRenderModuleEntryComponents = [
  PieceHtmlContainerRenderComponent,
];

@NgModule({
  imports: [
    RouterModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    SharedComponentsModule
  ],
  declarations: pieceHtmlContainerRenderModuleEntryComponents,
  entryComponents: pieceHtmlContainerRenderModuleEntryComponents,
  providers: [
    CmcToCmsParserService,
    TranslateService,
  ],
})
export class PieceHtmlContainerRenderModule { }

export default pieceHtmlContainerRenderModuleEntryComponents;
